export default {
  Title: 'Clients',
  Action: 'Create new client',
  LeadsPage: 'See Leads',
  ClientStatus: 'Client status: ',
  Relationships: 'Relationships: ',
  Caregivers: 'Caregivers: ',
  Filter: {
    Search: 'Search',
    SearchPlaceholder: 'Name or Contact',
    Status: 'Status',
  },
};
